import React, { Component } from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import Dropdown from '_components/dropdown'

import styles from '../styles.css'

const menuItems = [
  { key: '100', name: 'Free' },
  { key: '200', name: 'Pro' },
  { key: '300', name: 'Team' },
]

class AddUserForm extends Component {
  static propTypes = {
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    editUserInfo: PropTypes.any,
  }

  static defaultProps = {}

  state = {
    _id: undefined,
    firstName: '',
    lastName: '',
    email: '',
    planType: 100,
    password: '',
    editing: false,
  }

  componentDidMount() {
    const { editUserInfo } = this.props
    this.nameInput.focus()
    if (editUserInfo && editUserInfo._id) {
      const { _id, name, email, planType } = editUserInfo
      this.setState({
        _id,
        firstName: name.first,
        lastName: name.last,
        email,
        planType,
        editing: true,
      })
    }
  }

  onInputChange = e => {
    e.preventDefault()

    const { id, value } = e.target

    this.setState({
      [id]: value,
    })
  }

  onDropDownChange = e => {
    const { id, value } = e.currentTarget

    this.setState({
      [id]: value * 1,
    })
  }

  onKeyPress = event => {
    if (event.key === 'Enter') {
      this.onConfirm(event)
    }
  }

  onConfirm = () => {
    this.props.onConfirm(this.state)
  }

  onCancel = () => {
    this.props.onCancel()
  }

  render() {
    const { firstName, lastName, email, password, planType, editing } = this.state
    return (
      <div className={classnames(styles.Grid, styles['Grid--alignCenter'])}>
        <input
          ref={input => {
            this.nameInput = input
          }}
          type="text"
          id="firstName"
          placeholder="First Name"
          value={firstName}
          onChange={this.onInputChange}
          className={classnames(styles['Grid-cell'], styles['u-sizeFit'], styles.input)}
          onKeyPress={this.onKeyPress}
        />
        <input
          type="text"
          id="lastName"
          placeholder="Last Name"
          value={lastName}
          onChange={this.onInputChange}
          className={classnames(styles['Grid-cell'], styles['u-sizeFit'], styles.input)}
          onKeyPress={this.onKeyPress}
        />
        <input
          type="text"
          id="email"
          placeholder="Email"
          value={email}
          onChange={this.onInputChange}
          className={classnames(styles['Grid-cell'], styles['u-sizeFit'], styles.input)}
          onKeyPress={this.onKeyPress}
        />
        {!editing && (
          <input
            type="text"
            id="password"
            placeholder="Password"
            value={password}
            onChange={this.onInputChange}
            className={classnames(styles['Grid-cell'], styles['u-sizeFit'], styles.input)}
            onKeyPress={this.onKeyPress}
          />
        )}
        <Dropdown
          id="planType"
          value={planType}
          onChange={this.onDropDownChange}
          menuItems={menuItems}
          className={classnames(styles['Grid-cell'], styles.dropdown)}
        />
        <div className={classnames(styles.Grid)}>
          <div className={classnames(styles['u-sizeFill'])}>
            <button
              onClick={this.onConfirm}
              className={classnames(styles['Grid-cell'], styles['u-sizeFit'], styles.button)}
            >
              SAVE
            </button>
            <button
              onClick={this.onCancel}
              className={classnames(styles['Grid-cell'], styles['u-sizeFit'], styles.button)}
            >
              CANCEL
            </button>
          </div>
        </div>
      </div>
    )
  }
}
export default AddUserForm



// WEBPACK FOOTER //
// ./src/views/admin/components/AddUserForm.js